<template>
  <app-layout>
    <Head title="Autoresponder"/>
    <template #header>
      <div class="flex justify-between">
        <h2 class="font-semibold text-xl text-gray-800 leading-tight">
          Autoresponders
        </h2>
        <Link href="/autoresponder/create"
          class="bg-orange-400 hover:bg-orange-500 active:bg-orange-600 focus:bg-orange-600 focus:ring-orange inline-flex items-center px-4 py-2 border border-transparent rounded-md font-bold text-xs text-white uppercase tracking-widest focus:outline-none transition ease-in-out duration-150">
        Create Autoresponder</Link>
      </div>
      <p>Automatically send messages when you receive specific incoming messages.</p>
    </template>

    <div class="max-w-7xl mx-auto flex mb-6">
      <div class="w-full p-2 sm:px-6 lg:px-8">
        <div class="bg-white shadow-xl p-4 sm:rounded-lg sm:p-6 lg:p-8 overflow-hidden relative">
          <autoresponder-table ref="autoresponderTable"></autoresponder-table>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import AutoresponderTable from "../../components/AutoresponderTable";

export default {
  mounted() {
  },
  components: {
    AppLayout,
    AutoresponderTable
  },
  data() {
    return {
    };
  },
};
</script>
